import MainService from './MainService';
import { loadPrintHeaderProfile } from './printHeaderStorage';

/**
 * HTML fragment for print layouts. Prefers server company profile; falls back to local import/storage.
 */
export async function getPrintHeaderHtml() {
  try {
    const profile = await MainService.GetCompanyProfile();
    const p = profile || {};
    const html = String(
      p.PrintHeader ||
        p.PDFHeaderTemplate ||
        p.pdfHeaderTemplate ||
        p.PdfHeaderTemplate ||
        ''
    ).trim();
    if (html) return html;
  } catch (e) {
    console.warn('getPrintHeaderHtml: could not load company profile', e);
  }
  const local = loadPrintHeaderProfile();
  return String(local.templateHtml || '').trim();
}
